module.exports = __webpack_public_path__ + "static/media/personal_info.047562d2.png";